import { oembedId } from './OembedStore';

export const updateOembedId = (value) => oembedId.update((oldValue) => value);
